// Stage 11 mirror of worker/src/utils/speech-category.ts.
// Keeping two small copies avoids a cross-runtime dependency while ensuring
// both halves agree on what CONVO vs SCRIPT means.

export type SpeechCategory = 'CONVO' | 'SCRIPT';
export type SpeechType = 'convo' | 'script' | 'all';

export function categoryOf(mode: string | null | undefined): SpeechCategory {
  if (mode === 'turn-tts' || mode === 'kokoro-tts') return 'CONVO';
  return 'SCRIPT';
}

export function isSpeechType(v: string): v is SpeechType {
  return v === 'convo' || v === 'script' || v === 'all';
}

export function speechTypeLabel(t: SpeechType): string {
  return t.toUpperCase();
}
